const directives = require('./directives')

module.exports = function (vueInstance) {
  directives(vueInstance)
}
